import axios, { AxiosRequestHeaders } from 'axios';
import Cookies from 'js-cookie';
import getConfig from 'next/config';

export const SERVICE_OS_API_PATHNAME = '/api/v2.2';

export const SERVICE_OS_API_AUTH_COOKIE_NAME = 'serviceos_sid';

export function getServiceOSAPIHeaders() {
  const config = getConfig().publicRuntimeConfig;

  const headers: AxiosRequestHeaders = {
    'X-Application':
      config.NEXT_PUBLIC_SERVICE_OS_KEY ||
      '8zhl6dflji6qr84t2iy5k57d2gwvn4pruhfpt0nf5621wjp0sxul7tz10x4aam28',
  };

  const sid = Cookies.get(SERVICE_OS_API_AUTH_COOKIE_NAME) || null;

  if (sid) {
    headers.Authorization = `Bearer ${sid}`;
  }

  return headers;
}

export function getServiceOSAPIBaseUrl() {
  const config = getConfig().publicRuntimeConfig;
  return new URL(
    SERVICE_OS_API_PATHNAME,
    config.NEXT_PUBLIC_SERVICE_OS_API_URL || 'https://urban.serviceos.com/'
  ).toString();
}

export function createServiceOSAxiosClient() {
  return axios.create({
    baseURL: getServiceOSAPIBaseUrl(),
    headers: getServiceOSAPIHeaders(),
  });
}
